export enum AuthorityInventary {
  MOVIMENTATION_INVENTORY_EDIT = '2.3.4',
  MOVIMENTATION_INVENTORY_DELETE = '2.3.3',
  MOVIMENTATION_INVENTORY_ADD = '2.3.2',
  MOVIMENTATION_INVENTORY_VIEW = '2.3.1',
  MOVIMENTATION_INVENTORY_REGISTRATION = '2.3',
}
